'use strict';

angular.module('imagetrend.components')
    .controller('ImportCliniciansModalController', ['$scope', '$modalInstance', 'Upload', function ($scope, $modalInstance, Upload) {

        $scope.vm = {
            file: null,
            file_content: null
        }
        $scope.uploading = false;
        $scope.working = false;

        $scope.fileChange = function () {
            if (!$scope.working) {
                $scope.uploading = false;
            }
        }

        $scope.fileUpdated = function (file) {
            $scope.working = true;
            Upload.base64DataUrl(file).then(function (content) {
                $scope.vm.file_content = content;
                $scope.working = false;
                $scope.uploading = false;
            })
        }

        $scope.filePicked = function () {
            $scope.uploading = true;
        }

        $scope.save = function () {
            if ($scope.vm.file != null) {
                $modalInstance.close({
                    file_name: $scope.vm.file.name,
                    file_content: $scope.vm.file_content
                });
            }
            else {
                $modalInstance.dismiss('cancel');
            }
        }

        $scope.close = function () {
            $modalInstance.dismiss('cancel');
        }
    }])
;